export const BatchMode = Object.freeze({
    EVAL: 'eval',
    BATCH: 'batch',
    EXTRACTION_EVAL: 'extraction_eval',
    EXTRACTION_BATCH: 'extraction_batch',
});

export const BatchType = Object.freeze({
    QNA: 'qna',
    EXTRACT: 'extract',
});
